import CoachingDashboard from './CoachingDashboard';

export default CoachingDashboard;
